/** packages/shared-components/src/components/KeyboardLayoutSelector/KeyboardLayoutSidebar.tsx */

import React from "react";
import { useTranslation } from "react-i18next";
import { KEY_LAYOUT_CATEGORIES } from "./keyboardLayoutData";

interface KeyboardLayoutSidebarProps {
  activeCategory: string;
  setActiveCategory: (categoryId: string) => void;
}

const KeyboardLayoutSidebar: React.FC<KeyboardLayoutSidebarProps> = ({
  activeCategory,
  setActiveCategory,
}) => {
  const { t } = useTranslation();
  const labelDict: Record<string, string> = {
    "keyboard.keyCategory.basic": t("keyboard.keyCategory.basic"),
    "keyboard.keyCategory.special": t("keyboard.keyCategory.special"),
    "keyboard.keyCategory.media": t("keyboard.keyCategory.media"),
    "keyboard.keyCategory.tool": t("keyboard.keyCategory.tool"),
    "keyboard.keyCategory.light": t("keyboard.keyCategory.light"),
    "keyboard.keyCategory.control": t("keyboard.keyCategory.control"),
    "keyboard.keyCategory.mouse": t("keyboard.keyCategory.mouse"),
    "keyboard.keyCategory.macro": t("keyboard.keyCategory.macro"),
  };
  const getLabel = (key: string | undefined) => {
    if (!key) return "";
    return labelDict[key] ?? key;
  };
  return (
    <div className="keyboard-layout-selector-sidebar">
      {KEY_LAYOUT_CATEGORIES().map((category) => (
        <button
          key={category.id}
          className={`keyboard-layout-selector-tab ${
            activeCategory === category.id ? "active" : ""
          }`}
          onClick={() => {
            if (activeCategory !== category.id) {
              setActiveCategory(category.id);
            }
          }}
        >
          {/* <span className="tab-indicator"></span> */}
          <span className="tab-label">{getLabel(category.labelKey)}</span>
        </button>
      ))}
    </div>
  );
};

export default KeyboardLayoutSidebar;
